// import PropTypes from "prop-types";
// import Skeleton from "@mui/material/Skeleton";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableContainer from "@mui/material/TableContainer";
// import TableRow from "@mui/material/TableRow";
// import TableCell from "@mui/material/TableCell";
// import Autocomplete from "@mui/material/Autocomplete";
// import Icon from "@mui/material/Icon";

// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDPagination from "components/MDPagination";
// import DataTableBodyCell from "./DataTableBodyCell";
// import DataTableHeadCell from "./DataTableHeadCell";

// function DataTable({
//   table,
//   loading,
//   page,
//   pageSize,
//   totalCount,
//   onPageChange,
//   onPageSizeChange,
//   pagination = { variant: "gradient", color: "info" },
//   showTotalEntries = true,
// }) {
//   const columns = table?.columns || [];
//   const rows = table?.rows || [];

//   const totalPages = Math.ceil(totalCount / pageSize);
//   const pageOptions = [...Array(totalPages).keys()];

//   const entriesStart = page * pageSize + 1;
//   const entriesEnd = Math.min((page + 1) * pageSize, totalCount);

//   return (
//     <TableContainer sx={{ boxShadow: "none" }}>
//       {/* HEADER */}
//       <MDBox display="flex" justifyContent="space-between" p={3}>
//         <MDBox display="flex" alignItems="center">
//           <Autocomplete
//             disableClearable
//             value={pageSize.toString()}
//             options={["5", "10", "15", "20", "25"]}
//             onChange={(e, value) => onPageSizeChange(Number(value))}
//             size="small"
//             sx={{ width: "5rem" }}
//             renderInput={(params) => <MDInput {...params} />}
//           />
//           <MDTypography variant="caption" ml={1}>
//             entries per page
//           </MDTypography>
//         </MDBox>
//       </MDBox>

//       {/* TABLE */}
//       <Table>
//         <MDBox component="thead">
//           <TableRow>
//             {columns.map((col, i) => (
//               <DataTableHeadCell key={i}>{col.Header}</DataTableHeadCell>
//             ))}
//           </TableRow>
//         </MDBox>

//         <TableBody>
//           {/* LOADING */}
//           {loading &&
//             [...Array(pageSize)].map((_, i) => (
//               <TableRow key={i}>
//                 {columns.map((_, j) => (
//                   <DataTableBodyCell key={j}>
//                     <Skeleton height={20} />
//                   </DataTableBodyCell>
//                 ))}
//               </TableRow>
//             ))}

//           {/* DATA */}
//           {!loading &&
//             rows.map((row, i) => (
//               <TableRow key={i}>
//                 {columns.map((col, j) => (
//                   <DataTableBodyCell key={j}>{row[col.accessor]}</DataTableBodyCell>
//                 ))}
//               </TableRow>
//             ))}

//           {/* EMPTY */}
//           {!loading && rows.length === 0 && (
//             <TableRow sx={{ height: 220 }}>
//               <TableCell colSpan={columns.length} align="center">
//                 <Icon sx={{ color: "text.secondary", mb: 1 }}>inbox</Icon>
//                 <MDTypography variant="caption">No records available</MDTypography>
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>

//       {/* FOOTER (SAME LOOK) */}
//       <MDBox display="flex" justifyContent="space-between" p={3}>
//         {showTotalEntries && (
//           <MDTypography variant="button" color="secondary">
//             Showing {entriesStart} to {entriesEnd} of {totalCount} entries
//           </MDTypography>
//         )}

//         {totalPages > 1 && (
//           <MDPagination variant={pagination.variant} color={pagination.color}>
//             <MDPagination item disabled={page === 0} onClick={() => onPageChange(page - 1)}>
//               <Icon>chevron_left</Icon>
//             </MDPagination>

//             {pageOptions.map((option) => (
//               <MDPagination
//                 key={option}
//                 item
//                 active={page === option}
//                 onClick={() => onPageChange(option)}
//               >
//                 {option + 1}
//               </MDPagination>
//             ))}

//             <MDPagination
//               item
//               disabled={page === totalPages - 1}
//               onClick={() => onPageChange(page + 1)}
//             >
//               <Icon>chevron_right</Icon>
//             </MDPagination>
//           </MDPagination>
//         )}
//       </MDBox>
//     </TableContainer>
//   );
// }

// DataTablePagination.defaultProps = {
//   loading: false,
//   canSearch: false,
//   showTotalEntries: true,
//   isSorted: true,
//   noEndBorder: false,
//   entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
//   pagination: {
//     variant: "gradient",
//     color: "info",
//   },
// };

// DataTablePagination.propTypes = {
//   // existing props
//   table: PropTypes.shape({
//     columns: PropTypes.array.isRequired,
//     rows: PropTypes.array.isRequired,
//   }).isRequired,

//   loading: PropTypes.bool,

//   page: PropTypes.number.isRequired,
//   pageSize: PropTypes.number.isRequired,
//   totalCount: PropTypes.number.isRequired,

//   onPageChange: PropTypes.func.isRequired,
//   onPageSizeChange: PropTypes.func.isRequired,

//   // 🔽 MISSING props (eslint errors)
//   entriesPerPage: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
//   canSearch: PropTypes.bool,
//   showTotalEntries: PropTypes.bool,
//   isSorted: PropTypes.bool,
//   noEndBorder: PropTypes.bool,

//   pagination: PropTypes.shape({
//     variant: PropTypes.oneOf(["contained", "gradient"]),
//     color: PropTypes.oneOf([
//       "primary",
//       "secondary",
//       "info",
//       "success",
//       "warning",
//       "error",
//       "dark",
//       "light",
//     ]),
//   }),
// };

// export default DataTablePagination;
/* eslint-disable react/prop-types */
// import { useMemo, useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import Skeleton from "@mui/material/Skeleton";

// // react-table
// import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";

// // MUI
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableContainer from "@mui/material/TableContainer";
// import TableRow from "@mui/material/TableRow";
// import TableCell from "@mui/material/TableCell";
// import Icon from "@mui/material/Icon";
// import Autocomplete from "@mui/material/Autocomplete";

// // Material Dashboard components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDPagination from "components/MDPagination";

// // Table cells
// import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
// import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";

// function DataTablePagination({
//   entriesPerPage,
//   canSearch,
//   showTotalEntries,
//   table,
//   pagination,
//   isSorted,
//   noEndBorder,
//   loading,
//   onPageChange, // 🔥 NEW (optional)
// }) {
//   const defaultValue = entriesPerPage?.defaultValue || 10;
//   const entries = entriesPerPage?.entries
//     ? entriesPerPage.entries.map((el) => el.toString())
//     : ["5", "10", "15", "20", "25"];

//   const columns = useMemo(() => table.columns || [], [table]);
//   const data = useMemo(() => table.rows || [], [table]);

//   //   const tableInstance = useTable(
//   //     { columns, data, initialState: { pageIndex: 0 }, manualPagination: true },
//   //     useGlobalFilter,
//   //     useSortBy,
//   //     usePagination
//   //   );

//   const tableInstance = useTable(
//     {
//       columns,
//       data,
//       manualPagination: true, // 🔥 IMPORTANT
//       pageCount: table.pageCount, // 🔥 total pages from server
//       initialState: { pageIndex: 0 },
//     },
//     useSortBy,
//     usePagination
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     rows,
//     page,
//     pageOptions,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     setGlobalFilter,
//     state: { pageIndex, pageSize, globalFilter },
//   } = tableInstance;

//   useEffect(() => {
//     setPageSize(defaultValue);
//   }, [defaultValue, setPageSize]);

//   const setEntries = (value) => {
//     setPageSize(value);
//     gotoPage(0);
//     onPageChange?.(0, value);
//   };

//   const renderPagination = pageOptions.map((option) => (
//     <MDPagination
//       item
//       key={option}
//       active={pageIndex === option}
//       onClick={() => {
//         gotoPage(option);
//         onPageChange?.(option, pageSize);
//       }}
//     >
//       {option + 1}
//     </MDPagination>
//   ));

//   const [search, setSearch] = useState(globalFilter);

//   const onSearchChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 300);

//   const setSortedValue = (column) => {
//     if (!isSorted) return false;
//     if (column.isSorted) return column.isSortedDesc ? "desc" : "asce";
//     return "none";
//   };

//   const entriesStart = pageIndex === 0 ? 1 : pageIndex * pageSize + 1;
//   const entriesEnd =
//     pageIndex === pageOptions.length - 1 ? rows.length : (pageIndex + 1) * pageSize;

//   return (
//     <TableContainer sx={{ boxShadow: "none" }}>
//       <Table {...getTableProps()}>
//         <MDBox component="thead">
//           {headerGroups.map((headerGroup) => (
//             <TableRow {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
//               {headerGroup.headers.map((column) => (
//                 <DataTableHeadCell
//                   key={column.id}
//                   {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
//                   align={column.align || "left"}
//                   sorted={setSortedValue(column)}
//                 >
//                   {column.render("Header")}
//                 </DataTableHeadCell>
//               ))}
//             </TableRow>
//           ))}
//         </MDBox>

//         <TableBody {...getTableBodyProps()}>
//           {/* LOADING */}
//           {loading &&
//             [...Array(pageSize)].map((_, i) => (
//               <TableRow key={i}>
//                 {columns.map((_, j) => (
//                   <DataTableBodyCell key={j}>
//                     <Skeleton height={20} />
//                   </DataTableBodyCell>
//                 ))}
//               </TableRow>
//             ))}

//           {/* DATA */}
//           {!loading &&
//             page.map((row) => {
//               prepareRow(row);
//               return (
//                 <TableRow {...row.getRowProps()} key={row.id}>
//                   {row.cells.map((cell) => (
//                     <DataTableBodyCell
//                       key={cell.column.id}
//                       align={cell.column.align || "left"}
//                       noBorder={noEndBorder}
//                       {...cell.getCellProps()}
//                     >
//                       {cell.render("Cell")}
//                     </DataTableBodyCell>
//                   ))}
//                 </TableRow>
//               );
//             })}

//           {/* EMPTY */}
//           {!loading && page.length === 0 && (
//             <TableRow sx={{ height: 220 }}>
//               <TableCell colSpan={columns.length} sx={{ borderBottom: "none" }}>
//                 <MDBox
//                   height="100%"
//                   display="flex"
//                   flexDirection="column"
//                   alignItems="center"
//                   justifyContent="center"
//                 >
//                   <Icon sx={{ color: "text.secondary", mb: 1 }}>inbox</Icon>
//                   <MDTypography variant="caption" color="secondary">
//                     No records available
//                   </MDTypography>
//                 </MDBox>
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>

//       <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
//         {showTotalEntries && (
//           <MDTypography variant="button" color="secondary">
//             Showing {entriesStart} to {entriesEnd} of {rows.length} entries
//           </MDTypography>
//         )}

//         {pageOptions.length > 1 && (
//           <MDPagination variant={pagination.variant} color={pagination.color}>
//             {canPreviousPage && (
//               <MDPagination
//                 item
//                 onClick={() => {
//                   previousPage();
//                   onPageChange?.(pageIndex - 1, pageSize);
//                 }}
//               >
//                 <Icon>chevron_left</Icon>
//               </MDPagination>
//             )}

//             {renderPagination}

//             {canNextPage && (
//               <MDPagination
//                 item
//                 onClick={() => {
//                   nextPage();
//                   onPageChange?.(pageIndex + 1, pageSize);
//                 }}
//               >
//                 <Icon>chevron_right</Icon>
//               </MDPagination>
//             )}
//           </MDPagination>
//         )}
//       </MDBox>
//     </TableContainer>
//   );
// }

// DataTablePagination.defaultProps = {
//   entriesPerPage: { defaultValue: 10, entries: [5, 10, 15, 20, 25] },
//   canSearch: false,
//   showTotalEntries: true,
//   pagination: { variant: "gradient", color: "info" },
//   isSorted: true,
//   noEndBorder: false,
//   loading: false,
// };

// DataTablePagination.propTypes = {
//   entriesPerPage: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
//   canSearch: PropTypes.bool,
//   showTotalEntries: PropTypes.bool,
//   table: PropTypes.shape({
//     columns: PropTypes.array.isRequired,
//     rows: PropTypes.array.isRequired,
//   }).isRequired,
//   pagination: PropTypes.object,
//   isSorted: PropTypes.bool,
//   noEndBorder: PropTypes.bool,
//   loading: PropTypes.bool,
//   onPageChange: PropTypes.func, // 🔥 NEW
// };

// export default DataTablePagination;

// /* eslint-disable react/prop-types */
// import { useMemo, useEffect } from "react";
// import PropTypes from "prop-types";
// import Skeleton from "@mui/material/Skeleton";

// // react-table
// import { useTable, usePagination, useSortBy } from "react-table";

// // MUI
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableContainer from "@mui/material/TableContainer";
// import TableRow from "@mui/material/TableRow";
// import TableCell from "@mui/material/TableCell";
// import Icon from "@mui/material/Icon";
// import Autocomplete from "@mui/material/Autocomplete";

// // Material Dashboard
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDPagination from "components/MDPagination";

// // Cells
// import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
// import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";

// function DataTablePagination({
//   table,
//   loading,
//   page,
//   pageSize,
//   onPageChange,
//   onPageSizeChange,
//   pagination = { variant: "gradient", color: "info" },
//   showTotalEntries = true,
// }) {
//   const columns = useMemo(() => table.columns || [], [table]);
//   const data = useMemo(() => table.rows || [], [table]);

//   const tableInstance = useTable(
//     {
//       columns,
//       data,
//       manualPagination: true, // 🔥 SERVER SIDE
//       pageCount: table.pageCount, // 🔥 FROM API
//       initialState: { pageIndex: page },
//     },
//     useSortBy,
//     usePagination
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     page: tablePage,
//     gotoPage,
//     previousPage,
//     nextPage,
//     state: { pageIndex },
//   } = tableInstance;

//   // keep react-table in sync with parent page
//   useEffect(() => {
//     gotoPage(page);
//   }, [page, gotoPage]);

//   const pageOptions = [...Array(table.pageCount).keys()];

//   const entriesStart = page * pageSize + 1;
//   const entriesEnd = Math.min((page + 1) * pageSize, table.totalCount);

//   return (
//     <TableContainer sx={{ boxShadow: "none" }}>
//       {/* HEADER */}
//       {/* <MDBox display="flex" justifyContent="space-between" p={3}>
//         <MDBox display="flex" alignItems="center">
//           <Autocomplete
//             disableClearable
//             value={pageSize.toString()}
//             options={["5", "10", "15", "20", "25"]}
//             onChange={(e, value) => onPageSizeChange(Number(value))}
//             size="small"
//             sx={{ width: "5rem" }}
//             renderInput={(params) => <MDInput {...params} />}
//           />
//           <MDTypography variant="caption" ml={1}>
//             entries per page
//           </MDTypography>
//         </MDBox>
//       </MDBox> */}

//       {/* TABLE */}
//       <Table {...getTableProps()}>
//         <MDBox component="thead">
//           {headerGroups.map((group) => (
//             <TableRow key={group.id} {...group.getHeaderGroupProps()}>
//               {group.headers.map((column) => (
//                 <DataTableHeadCell
//                   key={column.id}
//                   {...column.getHeaderProps(column.getSortByToggleProps())}
//                 >
//                   {column.render("Header")}
//                 </DataTableHeadCell>
//               ))}
//             </TableRow>
//           ))}
//         </MDBox>

//         <TableBody {...getTableBodyProps()}>
//           {/* LOADING */}
//           {loading &&
//             [...Array(pageSize)].map((_, i) => (
//               <TableRow key={i}>
//                 {columns.map((_, j) => (
//                   <DataTableBodyCell key={j}>
//                     <Skeleton height={20} />
//                   </DataTableBodyCell>
//                 ))}
//               </TableRow>
//             ))}

//           {/* DATA */}
//           {!loading &&
//             tablePage.map((row) => {
//               prepareRow(row);
//               return (
//                 <TableRow key={row.id} {...row.getRowProps()}>
//                   {row.cells.map((cell) => (
//                     <DataTableBodyCell key={cell.column.id}>
//                       {cell.render("Cell")}
//                     </DataTableBodyCell>
//                   ))}
//                 </TableRow>
//               );
//             })}

//           {/* EMPTY */}
//           {!loading && tablePage.length === 0 && (
//             <TableRow sx={{ height: 220 }}>
//               <TableCell colSpan={columns.length} align="center">
//                 <Icon sx={{ color: "text.secondary", mb: 1 }}>inbox</Icon>
//                 <MDTypography variant="caption">No records available</MDTypography>
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>

//       {/* FOOTER */}
//       <MDBox display="flex" justifyContent="space-between" p={3}>
//         {showTotalEntries && (
//           <MDTypography variant="button" color="secondary">
//             Showing {entriesStart} to {entriesEnd} of {table.totalCount} records
//           </MDTypography>
//         )}

//         {table.pageCount > 1 && (
//           <MDPagination variant={pagination.variant} color={pagination.color}>
//             <MDPagination item disabled={page === 0} onClick={() => onPageChange(page - 1)}>
//               <Icon>chevron_left</Icon>
//             </MDPagination>

//             {pageOptions.map((p) => (
//               <MDPagination key={p} item active={p === page} onClick={() => onPageChange(p)}>
//                 {p + 1}
//               </MDPagination>
//             ))}

//             <MDPagination
//               item
//               disabled={page === table.pageCount - 1}
//               onClick={() => onPageChange(page + 1)}
//             >
//               <Icon>chevron_right</Icon>
//             </MDPagination>
//           </MDPagination>
//         )}
//       </MDBox>
//     </TableContainer>
//   );
// }

// DataTablePagination.propTypes = {
//   table: PropTypes.shape({
//     columns: PropTypes.array.isRequired,
//     rows: PropTypes.array.isRequired,
//     totalCount: PropTypes.number.isRequired,
//     pageCount: PropTypes.number.isRequired,
//   }).isRequired,

//   loading: PropTypes.bool,
//   page: PropTypes.number.isRequired,
//   pageSize: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
//   onPageSizeChange: PropTypes.func.isRequired,

//   pagination: PropTypes.object,
//   showTotalEntries: PropTypes.bool,
// };

// export default DataTablePagination;
/* eslint-disable react/prop-types */
import { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import Skeleton from "@mui/material/Skeleton";
import { useTable, usePagination, useSortBy } from "react-table";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";

import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { Pagination } from "@mui/material";

// ---------------- Ellipsis Pagination Helper ----------------
const getEllipsisPages = (current, total, delta = 2) => {
  const pages = [];
  if (total <= 1) return [0];

  pages.push(0); // first page

  if (current - delta > 1) pages.push("left-ellipsis"); // left ellipsis

  for (let i = Math.max(1, current - delta); i <= Math.min(total - 2, current + delta); i++) {
    pages.push(i);
  }

  if (current + delta < total - 2) pages.push("right-ellipsis"); // right ellipsis

  if (total > 1) pages.push(total - 1); // last page
  return pages;
};

function DataTablePagination({
  table,
  loading,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pagination = { variant: "gradient", color: "info" },
  showTotalEntries = true,
}) {
  const columns = useMemo(() => table.columns || [], [table]);
  const data = useMemo(() => table.rows || [], [table]);

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true, // 🔥 SERVER SIDE
      pageCount: table.pageCount,
      initialState: { pageIndex: page },
    },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page: tablePage,
    gotoPage,
    state: { pageIndex },
  } = tableInstance;

  useEffect(() => {
    gotoPage(page);
  }, [page, gotoPage]);

  const entriesStart = page * pageSize + 1;
  const entriesEnd = Math.min((page + 1) * pageSize, table.totalCount);

  // ---------------- Ellipsis Pages ----------------
  const pageItems = getEllipsisPages(page, table.pageCount);

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <Table {...getTableProps()}>
        <MDBox component="thead">
          {headerGroups.map((group) => (
            <TableRow key={group.id} {...group.getHeaderGroupProps()}>
              {group.headers.map((column) => (
                <DataTableHeadCell
                  key={column.id}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                </DataTableHeadCell>
              ))}
            </TableRow>
          ))}
        </MDBox>

        <TableBody {...getTableBodyProps()}>
          {loading &&
            [...Array(pageSize)].map((_, i) => (
              <TableRow key={i}>
                {columns.map((_, j) => (
                  <DataTableBodyCell key={j}>
                    <Skeleton height={20} />
                  </DataTableBodyCell>
                ))}
              </TableRow>
            ))}

          {!loading &&
            tablePage.map((row) => {
              prepareRow(row);
              return (
                <TableRow key={row.id} {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <DataTableBodyCell key={cell.column.id}>
                      {cell.render("Cell")}
                    </DataTableBodyCell>
                  ))}
                </TableRow>
              );
            })}

          {!loading && tablePage.length === 0 && (
            <TableRow sx={{ height: 220 }}>
              <TableCell colSpan={columns.length} align="center">
                <Icon sx={{ color: "text.secondary", mb: 1 }}>inbox</Icon>
                <MDTypography variant="caption">No records available</MDTypography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <MDBox display="flex" justifyContent="space-between" p={3}>
        {showTotalEntries && (
          <MDTypography variant="button" color="secondary">
            Showing {entriesStart} to {entriesEnd} of {table.totalCount} records
          </MDTypography>
        )}

        {table.pageCount > 1 && (
          <Pagination
            count={table.pageCount}
            page={page + 1}
            onChange={(e, value) => onPageChange(value - 1)}
            variant="outlined"
            shape="rounded"
            showFirstButton
            showLastButton
            sx={{
              "& .Mui-selected": {
                backgroundColor: "#1890ff", // selected page background
                color: "#fff", // selected page text color
              },
              "& .MuiPaginationItem-root": {
                color: "#000", // non-selected pages
              },
            }}
          />
        )}
      </MDBox>
    </TableContainer>
  );
}

DataTablePagination.propTypes = {
  table: PropTypes.shape({
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    totalCount: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
  }).isRequired,

  loading: PropTypes.bool,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,

  pagination: PropTypes.object,
  showTotalEntries: PropTypes.bool,
};

export default DataTablePagination;
